import React from 'react';
import ImageComponent from '../../Common/ImageComponent';
const WebChatProfileImg = (props) => {
    // let localDb = new IndexedDb()
    // let mounted = false
    //  const { avatar = SampleProfile } = props
    // const {profileImg, setProfileImg} = useState("avatar")

    /**
    React.useEffect(() => {
        //    handleProfileImg();
    }, [])
    */
    /**
    //    const handleProfileImg = () => {
    //         let { avatar = SampleProfile } = props
    //         const { rostersnap, chatType } = props
    //         if(chatType !== undefined && chatType === 'groupchat'){
    //             //  avatar = GroupChatAvatarImg;
    //         }
    //         if(!rostersnap) {
    //             setProfileImg(profileImg);
    //             return;
    //         }
    //         localDb.getImageByKey(rostersnap, 'profileimages').then(blob => {
    //             if(props.rostersnap){
    //                 const blobUrl = window.URL.createObjectURL(blob);
    //                 setProfileImg({ profileImg: blobUrl });
    //             }
    //         }).catch(err => {
    //             if (!this.mounted) return
    //             setProfileImg(profileImg);
    //         })
    //     }


    //    const checkNotFound = (event) => {
    //         let { avatar = SampleProfile } = props
    //         const { chatType } = props;
    //         if(chatType !== undefined && chatType === 'groupchat'){
    //             // avatar = GroupChatAvatarImg;
    //         }
    //         event.target.src = avatar
    //     }
    */

    return (
        <ImageComponent
            name={props.name}
            chatType={props.chatType}
            imageToken={props.rostersnap}
            blocked={props.blocked}
        />)
}
export default WebChatProfileImg;